import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { RolePermission } from 'types/permissions_response';

export default function useRolePermissions(
  organizationId: string,
  roleId: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-role/v1/organizations/${organizationId}/roles/${roleId}/permissions`;
  return useQuery<RolePermission[], ServerErrorResponse>(
    ['role_permissions', organizationId, roleId],
    async () => {
      try {
        if (!organizationId || !roleId) {
          return [];
        }
        const respData = await fetcher({
          method: 'get',
          url: `${url}`,
        });
        const perms: RolePermission[] = respData?.content ?? [];

        return perms;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: false,
      enabled: !!organizationId && !!roleId,
      ...options,
    }
  );
}
